import { getVariableColor } from "./get-css-variable";

export const getTextStyle = (
  settings: Record<string, unknown>,
  option: "legend" | "annotation" | "axis",
) => {
  const labelTextStyle = {
    color: settings.color,
    fontSize: 12,
    fontStyle: "normal",
    fontWeight: "normal",
  };
  if (settings[option]) Object.assign(labelTextStyle, settings[option]);
  labelTextStyle.color = getVariableColor(labelTextStyle.color as string, true);
  if (settings.darkMode) labelTextStyle.color = "#FFFFFF";

  return labelTextStyle;
};
